import simpleSchema from "./RateStrategySchema"
import beamSchema from "./RateStrategyWithBeamSchema"

export { simpleSchema as RateStrategySchema }
export { beamSchema as RateStrategyWithBeamSchema }

export const getSchema = (
  beamEnabled = false,
  getParentChildRelationships = () => ({})
) => {
  return beamEnabled ? beamSchema(getParentChildRelationships) : simpleSchema
}

export default getSchema
